/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // --------------------------------------------------------------------
  // --------------------------------------------------------------------
  // CUSTOM CODE:
  // ------------------------------------------------------------------------
  // --------------------------------------------------------------------
  ("use strict");

  // --------------------------------------------------------------------
  // UTILS
  // --------------------------------------------------------------------
  const Utils = {
    debounce(fn, wait = 200) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), wait);
      };
    },
  };

  // --------------------------------------------------------------------
  // MODULE: Carousel Arrow Patching
  // --------------------------------------------------------------------
  const CarouselPatcher = {
    init() {
      if (typeof customElements === "undefined") return;
      const Carousel = customElements.get("flickity-carousel");
      if (!Carousel) return;

      const originalToggle = Carousel.prototype.toggleWrapperModifier;
      Carousel.prototype.toggleWrapperModifier = function () {
        const carouselEl = this.carousel;
        const isSplit =
          carouselEl?.hasAttribute("data-carousel") &&
          carouselEl.hasAttribute("data-carousel-split-image");

        if (isSplit) {
          this.wrapper?.classList.add("flickity-force-arrows-top");
          this.section?.classList.remove("not-moved-arrows");
        } else {
          originalToggle.call(this);
        }
      };
    },
  };

  // --------------------------------------------------------------------
  // MODULE: Video Optimization
  // --------------------------------------------------------------------
  const VideoLazyLoader = (() => {
    const MOBILE_MAX = 767;
    const ATTR_LOADED = "data-video-loaded";

    // stash real src into data-src
    function stash(video) {
      video.querySelectorAll("source").forEach((s) => {
        s.dataset.src = s.src;
        s.removeAttribute("src");
      });
    }

    // true if this video should load at current viewport
    function breakpointMatch(video) {
      const isMobile = window.innerWidth <= MOBILE_MAX;
      const role = video.dataset.videoRole; // 'desktop' | 'mobile' | undefined
      return (
        !role ||
        (role === "mobile" && isMobile) ||
        (role === "desktop" && !isMobile)
      );
    }

    // inject srcs back, load, and autoplay if desired
    function hydrate(video) {
      if (
        video.getAttribute(ATTR_LOADED) == "loaded" ||
        !breakpointMatch(video)
      )
        return;

      video.querySelectorAll("source").forEach((s) => {
        s.src = s.dataset.src;
      });
      video.load();

      if (video.autoplay || video.dataset.autoplay === "true") {
        video.muted = true; // for iOS
        video.play().catch(() => {});
      }
      video.setAttribute(ATTR_LOADED, "loaded");
    }

    // observe when video enters viewport
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            hydrate(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "200px" }
    );

    function init(root = document) {
      root
        .querySelectorAll(
          '[data-section-type="slideshow"]   video[data-lazy-video], ' +
            '[data-section-type="video"]       video[data-lazy-video]'
        )
        .forEach((video) => {
          stash(video);
          io.observe(video);
        });
    }

    function setup() {
      // initial pass on DOM ready
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => init());
      } else {
        init();
      }

      // re-run for editor sections
      document.addEventListener("shopify:section:load", (e) => init(e.target));

      // re-check breakpoints on resize-ish
      const mq = window.matchMedia(`(max-width:${MOBILE_MAX}px)`);
      mq.addEventListener("change", () => {
        document.querySelectorAll("video[data-lazy-video]").forEach((v) => {
          if (breakpointMatch(v)) {
            // Bring in the new‐breakpoint video
            hydrate(v);
            // If it was playing before, resume playback
            if (!v.paused && v.getAttribute("data-video-loaded") == "loaded") {
              v.play().catch(() => {});
            }
          } else if (v.getAttribute("data-video-loaded") == "loaded") {
            // Pause and “unload” the old‐breakpoint video
            v.pause();
            v.querySelectorAll("source").forEach((s) => {
              s.dataset.src = s.src;
              s.removeAttribute("src");
            });
            v.removeAttribute("data-video-loaded");
          }
        });
      });

      // pause/play on tab hide/show
      document.addEventListener("visibilitychange", () => {
        document.querySelectorAll("video[autoplay]").forEach((v) => {
          document.hidden ? v.pause() : v.play().catch(() => {});
        });
      });
    }

    return { setup };
  })();

  // --------------------------------------------------------------------
  // MODULE: TeeInBlue Customizer Positioning
  // --------------------------------------------------------------------
  const TeeInBlueCustomizer = {
    isProductPage() {
      return document.body.classList.contains("template-product");
    },

    getInsertionPoint() {
      return (
        document.querySelector(".product__block__price") ||
        document.querySelector("[data-product-title]") ||
        document.querySelector(".product__title")
      );
    },

    tryMove(wrapper) {
      const anchor = this.getInsertionPoint();
      if (anchor) {
        anchor.parentNode.insertBefore(wrapper, anchor.nextSibling);
      }
    },

    startObserving() {
      const container =
        document.querySelector("[data-product-form-outer]") ||
        document.querySelector("product-form");
      if (!container) {
        // retry until the product form exists
        return setTimeout(() => this.startObserving(), 200);
      }

      const observer = new MutationObserver((muts) => {
        for (let m of muts) {
          for (let node of m.addedNodes) {
            if (!(node instanceof HTMLElement)) continue;
            const wrapper = node.matches(".tee-form-wrapper")
              ? node
              : node.querySelector?.(".tee-form-wrapper");
            if (wrapper) {
              this.tryMove(wrapper);
              observer.disconnect();
              return;
            }
          }
        }
      });

      observer.observe(container, { childList: true, subtree: true });
    },

    init() {
      if (!this.isProductPage()) return;
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () =>
          this.startObserving()
        );
      } else {
        this.startObserving();
      }
    },
  };

  // TeeInBlue: Upsell Cart Customization_ID Property Cleaner (event-driven)
  // --------------------------------------------------------------------
  const UpsellCartCleaner = {
    removeProps() {
      document
        .querySelectorAll(".upcart-item-properties .upcart-item-property")
        .forEach((item) => {
          const label = item.querySelector("strong")?.textContent?.trim();
          if (
            label?.startsWith("_customization_id") ||
            label?.startsWith("Customization ID")
          ) {
            item.remove();
          }
        });
    },

    init() {
      // 1) Initial pass on DOM ready (in case cart:init doesn’t fire immediately)
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.removeProps());
      } else {
        this.removeProps();
      }

      document.addEventListener("theme:cart:init", () => this.removeProps());
      document.addEventListener("theme:cart:change", () => this.removeProps());
    },
  };

  // --------------------------------------------------------------------
  // BOOTSTRAP
  // --------------------------------------------------------------------
  CarouselPatcher.init();
  VideoLazyLoader.setup();
  TeeInBlueCustomizer.init();
  UpsellCartCleaner.init();
})();
